/**
 * LocaleAutoDetect — invisible component that runs useLocationLanguage on mount.
 *
 * Mounted at App level so the IP geo lookup happens once per session, well
 * after first paint (i18next has already resolved a fallback language from
 * localStorage / navigator / etc). If the IP geo says "India" and the user
 * is on a US English browser, the language flips after ~300-1000ms with no
 * layout shift since the i18n hot-swap re-renders translated nodes in place.
 *
 * Renders nothing. All work happens in the hook.
 */
import { useLocationLanguage } from "@/hooks/useLocationLanguage";

export function LocaleAutoDetect() {
  useLocationLanguage();
  return null;
}
